/* global Vue:true  */
import debug from "debug";

import StaticDataPlugin from './plugins/static-data-plugin.js';

const MODULE_NAME = 'app.core/vendor/vue';
const log = debug(MODULE_NAME);

const VUE_QUEUES = {};

export function addToQueue (name, fn) {
    const queue = VUE_QUEUES[name] || [];
    if (!VUE_QUEUES[name]) {
        VUE_QUEUES[name] = queue;
    }
    queue.push(fn);
}

export function processQueue (name, ...args) {
    const queue = VUE_QUEUES[name];
    if (!queue) {
        return;
    }

    while (queue.length) {
        queue.shift()(args);
    }
}

export function onBeforePlugins (fn) {
    addToQueue('before-plugins', fn);
}

export function onAfterPlugins (fn) {
    addToQueue('after-plugins', fn);
}

export function onBeforeInit (fn) {
    addToQueue('before-init', fn);
}

export function onAfterInit (fn) {
    addToQueue('after-init', fn);
}

export function onCreated (fn) {
    addToQueue('done', fn);
}

export function exec () {

    processQueue('before-init', window.App);

    log('init');
    // Set Vue Delimiters
    Vue.config.delimiters = ['${', '}'];
    Vue.config.unsafeDelimiters = ['${!', '!}'];

    processQueue('before-plugins', window.App);
    // plugins
    Vue.use(StaticDataPlugin);
    processQueue('after-plugins', window.App);

    processQueue('after-init', window.App);

    log('done');

}


/**
 * Idea: pre load server data into vuex
 */
// $('script[data-vuex-module]').each((index, element) => {
// 	const name = $(element).attr('data-vuex-module');
// 	const data = Object.freeze($(element).eval());
// 	Vuex.modules.add(name, data);
// })
//



// WEBPACK FOOTER //
// ./project/client/src/core/vendor/vue/index.js